import { Box, Center, Flex, Img, Skeleton, Text } from "@chakra-ui/react";
import Button from "../common/button";

const NoProductsFound = ({ clearFilters }) => {
  return (
    <Center
      width="100%"
      height="80%"
      alignItems="center"
      justifyContent="center"
    >
      <Box width="80%" alignSelf="center" justifyContent="center">
        <Img
          h="100px"
          _hover={{
            cursor: "pointer",
          }}
          margin="auto"
          fallback={<Skeleton w="100%" />}
          src={`${process.env.NEXT_PUBLIC_NEXTJS_URL}/empty_cart.png`}
        />
        <Flex
          width="100%"
          alignItems="center"
          flexDirection="column"
          justifyContent="center"
        >
          <Text textAlign="center" mt="10" mb="5" variant="cartItemDescription">
            No matching products found.
          </Text>
          <Button
            px="20.5px"
            title="Reset filters"
            backgroundColor="maroon"
            width={{ base: "175px", md: null }}
            handleClick={clearFilters}
          />
        </Flex>
      </Box>
    </Center>
  );
};

export default NoProductsFound;
